import DIV from '../../DOM/div/DIV.js';
import NAVHEADER from '../../DOM/nav/navbar/navheader/NAVHEADER.js';
import EL from '../../EL/EL.js';
import { makeStruct } from '../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../enums/ModelData.js';
// Model Structure
export const siteHeaderAttr = makeAttrStruct([
    ['class'],
    ['name']
]);
export const siteHeaderData = makeDataStruct([
    ['header']
]);
export const siteHeaderModel = makeStruct([
    ['attributes', siteHeaderAttr],
    ['data', siteHeaderData]
]);
// Simplified Model
export function siteheader(header, className, name) {
    return {
        attributes: siteHeaderAttr(className, name),
        data: siteHeaderData(header)
    };
}
/** A Site Navigation Element */
export default class SITEHEADER extends DIV {
    // public logo: BUTTON<ButtonElementModel>;
    header;
    constructor(node, model) {
        super(node, model);
        this.addClass('site-header');
        this.header = new NAVHEADER(this, model.data.header);
        this.header.btnIcon.on('click', () => location.reload());
    }
}
export { EL };
